import React from "react"
import "react-day-picker/dist/style.css"
import { BrowserRouter as Router } from "react-router-dom"
import { ThemeProvider } from "styled-components"
import { theme } from "./styles/theme"
import GlobalStyle from "./styles/global"

import AppProvider from "./hooks"

import Routes from "./routes"

const App: React.FC = () => (
  <ThemeProvider theme={theme}>
    <Router>
      <AppProvider>
        <Routes />
      </AppProvider>

      <GlobalStyle />
    </Router>
  </ThemeProvider>
)

export default App
